import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class ImportApplicationController implements angular.IComponentController {
}

export const wtImportApplication: ComponentDefinition = {
    componentId: 'wtImportApplication',
    controller: ImportApplicationController,
    template: require('./importApplication.component.html'),
    controllerAs: 'vm',
    bindings: {
        applicationList: '<'
    }
};
